import { useEffect, useRef } from "react";
import styles from "./Welcome.module.css";
import { init } from "ityped";

function Welcome() {
  const textRef = useRef();
  useEffect(() => {
    init(textRef.current, {
      showCursor: false,
      strings: [
        "Software Engineer",
        "App Developer",
        "Researcher",
        "Tech Enthusiast",
      ],
    });
  }, []);
  return (
    <section id="welcome" className={styles.section}>
      <div className={styles.left}>
        <h1 className={styles.h1}>Hi! I'm Abiodun</h1>
        {/* <h2 className={styles.h2}>Your No. 1️⃣</h2> */}
        <h3 className={styles.h3}>
          Adept <span ref={textRef}></span>
        </h3>
        <p>
          Welcome to my portfolio website! I'm Abiodun Akanbi, an experienced
          Software Engineer specializing in web development. With a strong
          background in JavaScript, TypeScript, and a range of other
          technologies, I'm dedicated to crafting innovative solutions that
          empower businesses and enhance user experiences. Explore my journey
          and projects below to learn more about my skills and capabilities.
        </p>
        <div className={styles.linkContainer}>
          <a href="#contact" className={styles.intouch}>
            Get in touch
          </a>
        </div>
      </div>
      <div className={styles.right}>
        <img
          src={process.env.PUBLIC_URL + "/assets/img/abiodun.png"}
          alt="abiodun-akanbi.png"
          className={styles.img}
        />
      </div>
    </section>
  );
}

export default Welcome;
